export const DEFAULT_CARD_FORMAT = /(\d{1,4})/g;
export const PLACEHOLDER = {
  displayName: 'placeholder',
  type: 'generic',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /.*/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19]
};
export const CARD_TYPES = [{
  displayName: 'Visa',
  type: 'visa',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^4/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19]
}, {
  displayName: 'Mastercard',
  type: 'mastercard',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
  gaps: [4, 8, 12],
  lengths: [16]
}, {
  displayName: 'American Express',
  type: 'american-express',
  format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  startPattern: /^3[47]/,
  gaps: [4, 10],
  lengths: [15]
}, {
  displayName: 'Diners Club',
  type: 'diners-club',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(36|38|30[0-5])/,
  gaps: [4, 10],
  lengths: [14, 16, 19]
}, {
  displayName: 'Discover',
  type: 'discover',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(6011|65|64[4-9]|622)/,
  gaps: [4, 8, 12],
  lengths: [16, 19]
}];
export const getCardTypeByValue = value => CARD_TYPES.filter(cardType => cardType.startPattern.test(value))[0] ?? PLACEHOLDER;
export const getCardTypeByType = type => CARD_TYPES.filter(cardType => cardType.type === type)[0];